import { apiGatewayEndpoints } from '~/services/arcane-api-gateway/api-gateway-endpoints';
import FormsBuilder from '~/services/filter-form-service/FilterFormBuilder';

export class FilterFormService {
  constructor({ store, arcaneApiGateway }) {
    this.store = store;
    this.arcaneApiGateway = arcaneApiGateway;
    this.formBuilder = new FormsBuilder();
  }

  /**
   * Data to populate the filter dropdowns based on the available data in Opensearch.
   */
  async getFilterForm(type = 'document') {
    try {
      const { data } = await this.arcaneApiGateway.post(apiGatewayEndpoints.filters.conversationFilters, {
        type,
      });

      this.form = this.formBuilder.buildForm(data.filters);
      return this.form;
    } catch (error) {
      console.log('error in getting filters', error);
      return [];
    }
  }

  async getUpdatedFilterForm(type = 'document', selectedFilters = {}) {
    const { data } = await this.arcaneApiGateway.post(apiGatewayEndpoints.filters.conversationFilters, {
      selectedFilters,
      type,
    });

    const newForm = this.formBuilder.buildForm(data.filters);

    this.form = this.form.map((formFilter) => {
      const newFilter = newForm.find((filterConfig) => filterConfig.id === formFilter.id);
      return { ...formFilter, ...newFilter };
    });

    return this.form;
  }
}
